/**
 用于倒计时显示的Text组件
 1 声明组件
 <CountDownText ref='countDownText' startText='开始计时' endText='结束计时' intervalText={(sec) => '还有' + sec + 's'} />
 2 开始计时
 this.refs.countDownText.start();
 3 结束计时
 this.refs.countDownText.end();
 */

'use strict'

import React from 'react';
import CountDown from './CountDown.js'


class CountDownText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            text: this.props.startText, // 要显示文本
        }
    }

    isTimeEquals = (t1, t2) => {
        var threshold = 2;
        return Math.abs(t1 - t2) < threshold;
    }

    // 定时调用 intervalText 来更新状态 text
    onInterval = (timePassed) => {
        if (this.props.intervalText)
            this.setState({text: this.props.intervalText(timePassed)})
    }

    onEnd = (timePassed) => {
        this.setState({text: this.props.endText}, () => {
            // 重置：清空计数 + 停止计时
            this.counter.reset();
            // 重新初始化计时器
            var config = Object.assign({}, this.props, {
                onInterval: this.onInterval.bind(this),
                onEnd: this.onEnd.bind(this)
            });

            this.counter.setData(config);
            this.props.afterEnd && this.props.afterEnd();
        });
    }

    // 开始计时
    start = () => {
        this.counter.start();
    }
    // 结束计时
    end = () => {
        this.counter.end();
    }
    // 重置
    reset = () => {
        this.counter.reset();
    }
    render = () => {
        return <p style={this.props.style}>{this.state.text}</p>
    }
    getTimePassed = () => {
        return this.counter.timePassed;
    }

    componentDidMount() {
        /*
       this.counter = CountDown({
           countType: "seconds",
           onInterval: (sec) => {},// 定时回调
           onEnd: (timePassed) => {}, // 结束回调
           timeLeft: 60,//正向计时 时间起点为0秒
           step: -1, // 计时步长，以秒为单位，正数则为正计时，负数为倒计时
       });
       */
        // 创建计时器
        var config = Object.assign({}, this.props, { // 不能直接修改 this.props，因此使用 update.$merge
            onInterval: this.onInterval.bind(this), // 定时回调
            onEnd: this.onEnd.bind(this) // 结束回调
        });
        this.counter = CountDown(config);

        // 判断是否结束
        if (this.counter.timeLeft <= 0 && this.counter.step <= 0) {
            this.end();
            return;
        }

        // 自动开始
        if (this.props.auto) {
            this.start();
        }
    }

    componentWillUnmount() {
        // 重置倒计时
        this.reset();
    }

}

CountDownText.contextTypes = {}

CountDownText.defaultProps = {
    countType: "seconds",
    afterEnd: null, // 结束回调
    timeLeft: 0,//正向计时 时间起点为0秒
    step: -1, // 计时步长，以秒为单位，正数则为正计时，负数为倒计时
    startText: null, // 开始的文本
    intervalText: null, // 定时的文本，可以是回调函数
    endText: null, // 结束的文本
    auto: false, // 是否自动开始
}

CountDownText.propTypes = {}

export default CountDownText;


// WEBPACK FOOTER //
// ./src/components/countdown/CountDownText.jsx